<template>
  <div>
    <div class="services style-2 home s-2 bottom-3">

      <div class="container main-content clearfix">

        <carousel :perPage="1"
                  :loop="true"
                  autoplay
                  autoplayHoverPause
                  :speed="300"
                  :autoplayTimeout="8000"
                  navigationEnabled
                  :navigationClickTargetSize="12"
                  :paginationEnabled="false">

          <slide>
            <img src="../../assets/images/photo/Team_photo_IMG_4626_960x224.jpg">
          </slide>
          <slide>
            <img src="../../assets/images/photo/Team_photo_PH2_5678_960x224.jpg">
          </slide>
          <slide>
            <img src="../../assets/images/photo/Team_photo_IMG_8716_DxO_960x224.jpg">
          </slide>
        </carousel>

        <div class="slider-2 clearfix"></div>

        <div class="sixteen columns clearfix"></div>
        <div class="container main-content clearfix" style="padding-top: 10px"></div>
        <div class="container clearfix"></div>

        <div class="four columns">
          <div class="item bottom-3">
            <p><i class="icon-envelope-alt s-20" aria-hidden="true"></i> info@narabi.nl</p>
          </div>
        </div><!-- End item -->

        <div class="four columns">
          <div class="item bottom-3">
            <p>
              <i class="icon-map-marker s-20"></i> Den&nbsp;Haag</p>
          </div>
        </div><!-- End item -->

        <div class="four columns">
          <div class="item bottom-3">
            <p><i class="icon-phone s-20" aria-hidden="true"></i> 06-30733748</p>
          </div>
        </div><!-- End item -->

        <div class="four columns">
          <div class="item bottom-3">
            <p><i class="icon-barcode s-20" aria-hidden="true"></i> KvK Den Haag: 64514854</p>
          </div>
        </div><!-- End item -->
      </div>

      <div class="services style-3 home bottom-3" style="padding: 10px 0;">
        <div class="container clearfix">
          <h3 class="title" style="padding: 7px">{{ $t('contact_management') }}:</h3>
          <div class="eight columns">
            <div class="item bottom-3">
              <p><i class="icon-linkedin s-20"></i> <a href="https://www.linkedin.com/in/tom-narabi"> Tamás Magyar</a> {{ $t('contact_ceo')
                }}
              </p>
              <p><i class="icon-comment s-20"></i> {{ $t('contact_email') }}: tom@narabi.nl</p>
            </div>
          </div><!-- End item -->

          <div class="eight columns">
            <div class="item bottom-3">
              <p><i class="icon-linkedin s-20"></i> <a href="https://www.linkedin.com/in/peter-narabi"> Péter Szekszárdi</a> {{
                $t('contact_cso') }}</p>
              <p><i class="icon-comment s-20"></i> {{ $t('contact_email') }}: peter@narabi.nl</p>
            </div>
          </div><!-- End item -->
          <div style="margin: auto; text-align: center;"><img src="../../assets/images/photo/MT-SZP_PH2_5853_960x355.jpg">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Contact',
  data () {
    return {}
  }
}
</script>

<style>
</style>
